import React from 'react';
import { Theme, Box, Typography, makeStyles, Card } from '@material-ui/core';
import { ReportConfiguration, ReportType, Site } from '../../../models';
import { ReportMenuType, ReportMenu } from '../../../models';
import { getDescriptionReportTemplate, getIconReportTemplate } from 'src/helpers/reports';
import { dividerColor } from 'src/data/colors';
import { FORTRESS_GUARDIAN } from 'src/data/constants';

interface Props {
  configurations: ReportConfiguration[];
  onReportTypeChange: (type: ReportMenuType) => void;
  site: Site;
}

const useStyles = makeStyles((theme: Theme) => ({
  menuItem: {
    padding: 16,
    border: `1px solid ${dividerColor}`,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
    boxShadow: 'none',
    cursor: 'pointer',
  },
  container: {
    padding: 24,
  },
  title: {
    fontWeight: 500,
    fontSize: 26,
    marginBottom: 22,
  },
  gridContainer: {
    display: 'grid',
    gap: theme.spacing(1),
    gridTemplateColumns: 'repeat(4, 1fr)',

    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  image: {
    marginBottom: 16,
  },
  itemTitle: {
    marginBottom: 8,
  },
}));

const ReportTypeMenu: React.FC<Props> = ({ configurations, onReportTypeChange, site }) => {
  const validConfigurations = site.dataPartnerId !== FORTRESS_GUARDIAN ? configurations : [];
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Typography className={classes.title}>Choose Template</Typography>
      <Box className={classes.gridContainer}>
        {validConfigurations.map((config) => (
          <Card
            className={classes.menuItem}
            onClick={() => onReportTypeChange(config.reportName as ReportType)}
            key={config.reportName}
          >
            <img
              src={getIconReportTemplate(config.reportName as ReportType)}
              alt="icon"
              className={classes.image}
            />
            <Typography variant="h6" className={classes.itemTitle}>
              {config.reportName}
            </Typography>
            <Typography variant="body2">
              {getDescriptionReportTemplate(
                config.reportName as ReportType,
                config.availableTimePeriods
              )}
            </Typography>
          </Card>
        ))}
        <Card className={classes.menuItem} onClick={() => onReportTypeChange(ReportMenu.EXPORT)}>
          <img
            src={getIconReportTemplate(ReportMenu.EXPORT)}
            alt="icon"
            className={classes.image}
          />
          <Typography variant="h6" className={classes.itemTitle}>
            {ReportMenu.EXPORT}
          </Typography>
          <Typography variant="body2">
            Generate a report using custom tags and time range.
          </Typography>
        </Card>
      </Box>
    </div>
  );
};

export default ReportTypeMenu;
